import { render, staticRenderFns } from "./ChangePassFinished.vue?vue&type=template&id=65a8b5fa&"
import script from "./ChangePassFinished.vue?vue&type=script&lang=js&"
export * from "./ChangePassFinished.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports